// TODO (https://app.clickup.com/t/14117868/ENG-1585) move hubspotPageUrl to customerInfo json
export const CUSTOMER_CONTEXT_LINKS = {
  "amg-vanadium-zanesville": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20445801785",
  },
  "amg-vanadium": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20445801795",
  },
  "array-scarborough": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20465629581",
  },
  "barrettpetfoods-brainerd": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8957171333",
  },
  "barrettpetfoods-packaging": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8957171333",
  },
  "barrettpetfoods-production": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8957171333",
  },
  "bcg-demo": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/6180559387",
  },
  "catalyx-smartfactory": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/18108464787",
  },
  "clifford-jacobs": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/17304656540",
  },
  "daily-manufacturing": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/19074680388",
  },
  "eccomfg-calgary": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20465630565",
  },
  "eccomfg-langley": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20465630558",
  },
  "hef-usa": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/15270693550",
  },
  "icu-medical1": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8397595316",
  },
  "koppers-somerville": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20446792461",
  },
  "meritmedical-galway": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/9835048596",
  },
  "meritmedical-southjordan": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8483717126",
  },
  "meritmedical-tijuana": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8920924161",
  },
  "portlandforge-lebanon": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/10195196700",
  },
  "silvercote-brampton": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20441280396",
  },
  "silvercote-dallas": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20441280605",
  },
  "silvercote-denver": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20441852069",
  },
  "silvercote-duluth": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20441852191",
  },
  "silvercote-macedonia": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20441196460",
  },
  "silvercote-portland": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20441851768",
  },
  "silvercote-siouxfalls": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20441851938",
  },
  "silvercote-slc": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20441852012",
  },
  "silvercote-southcarolina": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20441852051",
  },
  "silvercote-springfield": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20441852084",
  },
  "silvercote-stockton": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20441280777",
  },
  "silvercote-wrightcity": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20441280889",
  },
  "sojo-bristol": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20465529888",
  },
  "sojo-cedarlane": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20465630026",
  },
  "sojo-denver": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20465529928",
  },
  "sojo-indianapolis": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20465630056",
  },
  "sojo-nevada": {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20465854898",
  },
  altiusspices: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/14084699420",
  },
  americhem: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/9157187459",
  },
  amforge: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/10417909560",
  },
  axiom: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/15949756700",
  },
  bazooka: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/10221420177",
  },
  chem: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-3/7405452155",
  },
  dt: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/6654827170",
  },
  evraz: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/9920219735",
  },
  gutter: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/6593243222",
  },
  guttertennessee: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/6795709023",
  },
  industrialrevolution: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/19199222312",
  },
  katz: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/16999545114",
  },
  koppers: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20446447724",
  },
  kruger: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/6701666622",
  },
  lb: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8133961872",
  },
  lbprairie: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8133910170",
  },
  merck: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/6901430415",
  },
  naturesway: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8125588643",
  },
  natureswaytwo: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/6654769025",
  },
  neotrez: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/17008137752",
  },
  nwmason: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8133854753",
  },
  pci: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/20445804043",
  },
  pciuk: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8071713412",
  },
  portlandforge: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8344949601",
  },
  qi: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8133754251",
  },
  qi2: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8133754251",
  },
  qi3: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8133754251",
  },
  quepasa: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/6157647748",
  },
  renaissance: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/6393085449",
  },
  sands: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/6654781481",
  },
  sbdwarrington: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8071743534",
  },
  sharp: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/9157187472",
  },
  silvercote: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/9801039395",
  },
  spartech: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/8535192328",
  },
  ssw: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/9156752178",
  },
  steris: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/6654823785",
  },
  sterisconroe: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/6862219331",
  },
  terrapure: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/6159480937",
  },
  terrapure2: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/6159480937",
  },
  waiakea: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/16077160629",
  },
  yamamotoyama: {
    hubspotPageUrl:
      "https://app.hubspot.com/contacts/19900759/record/0-2/6952266868",
  },
};
